<template>
  <div>
    <h2>色の名前</h2>
    <p class="left">
      ※モニターによって、色味が異なります。
    </p>
    <button
      class="btn"
      v-for="(item) in items"
      :key="item.color"
      :style="{ backgroundColor: item.color, color: item.fontColor }"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { name: "v1", color: "rgb(185,31,87)", label: "コチニールレッド", fontColor: "white" },
        { name: "v2", color: "rgb(208,47,72)", label: "レッド", fontColor: "white" },
        { name: "b2", color: "rgb(239,108,112)", label: "コーラルピンク", fontColor: "black" },
        { name: "dp2", color: "rgb(166,29,57)", label: "あかねいろ", fontColor: "white" },
        { name: "lt+2", color: "rgb(241,152,150)", label: "こうばいいろ", fontColor: "black" },
        { name: "sf2", color: "rgb(202,130,129)", label: "えんしゅうちゃ", fontColor: "black" },
        { name: "d2", color: "rgb(163,90,92)", label: "べにとび", fontColor: "white" },
        { name: "dk2", color: "rgb(105,41,52)", label: "くろがき", fontColor: "white" },
        { name: "p+2", color: "rgb(232,194,191)", label: "アンバーローズ", fontColor: "black" },
        { name: "ltg2", color: "rgb(192,171,170)", label: "ピンクベージュ", fontColor: "black" },
        { name: "g2", color: "rgb(116,92,92)", label: "ココアブラウン", fontColor: "white" },
        { name: "dkg2", color: "rgb(62,45,48)", label: "ボルドー", fontColor: "white" },
        { name: "v3", color: "rgb(221,68,59)", label: "バーミリオン", fontColor: "white" },
        { name: "PI1", color: "rgb(250,155,165)", label: "ひとえうめ", fontColor: "black" },
        { name: "PI2", color: "rgb(255,139,142)", label: "さんごいろ", fontColor: "black" },
        { name: "PI3", color: "rgb(243,83,130)", label: "アザレ", fontColor: "black" },
        { name: "PI4", color: "rgb(200,80,150)", label: "ショッキングピンク", fontColor: "white" },
        { name: "PI5", color: "rgb(252,188,194)", label: "パステルピンク", fontColor: "black" },
        { name: "PI6", color: "rgb(244,170,196)", label: "オールドオーキッド", fontColor: "black" },
        { name: "PI7", color: "rgb(241,127,154)", label: "チェリーピンク", fontColor: "black" },
        { name: "PI8", color: "rgb(234,88,119)", label: "オペラ", fontColor: "white" },
        { name: "PI9", color: "rgb(253,170,137)", label: "サーモンピンク", fontColor: "black" },
        { name: "PI10", color: "rgb(250,129,85)", label: "しゅいろ", fontColor: "black" },
        { name: "v4", color: "rgb(233,91,35)", label: "かきいろ", fontColor: "black" },
        { name: "b4", color: "rgb(250,129,85)", label: "みかんいろ", fontColor: "black" },
        { name: "dp4", color: "rgb(171,61,29)", label: "キャロットオレンジ", fontColor: "white" },
        { name: "lt+4", color: "rgb(255,167,135)", label: "しののめいろ", fontColor: "black" },
        { name: "sf4", color: "rgb(218,146,122)", label: "サハラ", fontColor: "black" },
        { name: "d4", color: "rgb(175,105,84)", label: "れんがいろ", fontColor: "white" },
        { name: "dk4", color: "rgb(117,54,42)", label: "おうかっしょく", fontColor: "white" },
        { name: "p+4", color: "rgb(235,194,181)", label: "おとめいろ", fontColor: "black" },
        { name: "v5", color: "rgb(230,120,0)", label: "オレンジ", fontColor: "black" },
        { name: "v6", color: "rgb(244,157,0)", label: "やまぶきいろ", fontColor: "black" },
        { name: "b6", color: "rgb(255,173,54)", label: "サンフラワー", fontColor: "black" },
        { name: "dp6", color: "rgb(177,108,0)", label: "ローシェンナ", fontColor: "white" },
        { name: "lt+6", color: "rgb(255,190,113)", label: "こうじいろ", fontColor: "black" },
        { name: "sf6", color: "rgb(219,166,107)", label: "えどちゃ", fontColor: "black" },
        { name: "d6", color: "rgb(179,127,70)", label: "こうぞめ", fontColor: "white" },
        { name: "dk6", color: "rgb(121,77,28)", label: "くりいろ", fontColor: "white" },
        { name: "p+6", color: "rgb(244,212,176)", label: "パステルオレンジ", fontColor: "black" },
        { name: "ltg6", color: "rgb(206,187,168)", label: "ベージュ", fontColor: "black" },
        { name: "v7", color: "rgb(241,181,0)", label: "うこんいろ", fontColor: "black" },
        { name: "v8", color: "rgb(238,201,0)", label: "きいろ", fontColor: "black" },
        { name: "b8", color: "rgb(250,216,49)", label: "イエロー", fontColor: "black" },
        { name: "dp8", color: "rgb(179,147,0)", label: "からしいろ", fontColor: "black" },
        { name: "lt+8", color: "rgb(242,217,110)", label: "レモンイエロー", fontColor: "black" },
        { name: "sf8", color: "rgb(211,189,108)", label: "くわぞめ", fontColor: "black" },
        { name: "d8", color: "rgb(171,148,70)", label: "なたねゆいろ", fontColor: "black" },
        { name: "dk8", color: "rgb(116,96,31)", label: "こびちゃ", fontColor: "white" },
        { name: "p+8", color: "rgb(242,230,184)", label: "パステルイエロー", fontColor: "black" },
        { name: "g8", color: "rgb(120,111,87)", label: "ウォームグレー", fontColor: "white" },
        { name: "v9", color: "rgb(210,193,0)", label: "ひわいろ", fontColor: "black" },
        { name: "v10", color: "rgb(168,187,0)", label: "もえぎ", fontColor: "black" },
        { name: "b10", color: "rgb(183,200,43)", label: "リーフグリーン", fontColor: "black" },
        { name: "dp10", color: "rgb(116,132,0)", label: "こけいろ", fontColor: "white" },
        { name: "lt+10", color: "rgb(199,211,109)", label: "シャトルーズグリーン", fontColor: "black" },
        { name: "sf10", color: "rgb(173,182,107)", label: "やなぎちゃ", fontColor: "black" },
        { name: "d10", color: "rgb(133,143,70)", label: "くさいろ", fontColor: "black" },
        { name: "dk10", color: "rgb(82,91,32)", label: "モスグリーン", fontColor: "white" },
        { name: "p+10", color: "rgb(216,221,173)", label: "うらはやなぎ", fontColor: "black" },
        { name: "v11", color: "rgb(88,169,29)", label: "せんりょく", fontColor: "black" },
        { name: "v12", color: "rgb(0,161,90)", label: "みどり", fontColor: "white" },
        { name: "b12", color: "rgb(65,184,121)", label: "コバルトグリーン", fontColor: "black" },
        { name: "dp12", color: "rgb(0,114,67)", label: "ふかみどり", fontColor: "white" },
        { name: "lt+12", color: "rgb(133,206,158)", label: "ミントグリーン", fontColor: "black" },
        { name: "sf12", color: "rgb(118,177,138)", label: "うすみどり", fontColor: "black" },
        { name: "d12", color: "rgb(79,135,102)", label: "さいたづまいろ", fontColor: "white" },
        { name: "dk12", color: "rgb(35,82,58)", label: "むしあお", fontColor: "white" },
        { name: "p+12", color: "rgb(174,212,185)", label: "あさみどり", fontColor: "black" },
        { name: "v13", color: "rgb(0,146,110)", label: "ターコイズグリーン", fontColor: "white" },
        { name: "v14", color: "rgb(0,133,127)", label: "あおみどり", fontColor: "white" },
        { name: "b14", color: "rgb(0,170,159)", label: "ピーコックブルー", fontColor: "black" },
        { name: "dp14", color: "rgb(0,102,100)", label: "ピーコックグリーン", fontColor: "white" },
        { name: "lt+14", color: "rgb(98,192,181)", label: "せいじいろ", fontColor: "black" },
        { name: "sf14", color: "rgb(84,163,155)", label: "サックスブルー", fontColor: "black" },
        { name: "d14", color: "rgb(42,123,118)", label: "たんばいろ", fontColor: "white" },
        { name: "dk14", color: "rgb(0,71,70)", label: "びろうど", fontColor: "white" },
        { name: "p+14", color: "rgb(166,212,204)", label: "あおたけいろ", fontColor: "black" },
        { name: "v16", color: "rgb(0,112,155)", label: "ダックブルー", fontColor: "white" },
        { name: "b16", color: "rgb(0,152,185)", label: "ターコイズブルー", fontColor: "black" },
        { name: "dp16", color: "rgb(0,84,118)", label: "ティールブルー", fontColor: "white" },
        { name: "lt+16", color: "rgb(91,175,196)", label: "しんばしいろ", fontColor: "black" },
        { name: "sf16", color: "rgb(81,146,164)", label: "カデブルー", fontColor: "black" },
        { name: "d16", color: "rgb(36,106,125)", label: "さびなんど", fontColor: "white" },
        { name: "dk16", color: "rgb(0,69,88)", label: "マリンブルー", fontColor: "white" },
        { name: "p+16", color: "rgb(173,209,218)", label: "ひそく", fontColor: "black" },
        { name: "v17", color: "rgb(0,96,156)", label: "セルリアンブルー", fontColor: "white" },
        { name: "v18", color: "rgb(0,91,165)", label: "コバルトブルー", fontColor: "white" },
        { name: "b18", color: "rgb(41,129,192)", label: "シアン", fontColor: "white" },
        { name: "dp18", color: "rgb(0,66,128)", label: "サファイアブルー", fontColor: "white" },
        { name: "lt+18", color: "rgb(108,154,197)", label: "スカイブルー", fontColor: "black" },
        { name: "sf18", color: "rgb(93,126,160)", label: "そら色", fontColor: "black" },
        { name: "d18", color: "rgb(52,89,125)", label: "せいらん", fontColor: "white" },
        { name: "dk18", color: "rgb(18,52,82)", label: "ネイビー", fontColor: "white" },
        { name: "p+18", color: "rgb(175,192,209)", label: "わすれなぐさ", fontColor: "black" },
        { name: "ltg18", color: "rgb(155,165,175)", label: "ライトブルーグレー", fontColor: "black" },
        { name: "v19", color: "rgb(26,84,165)", label: "るりいろ", fontColor: "white" },
        { name: "v20", color: "rgb(83,74,160)", label: "バイオレット", fontColor: "white" },
        { name: "b20", color: "rgb(117,116,188)", label: "ウィスタリア", fontColor: "white" },
        { name: "dp20", color: "rgb(62,51,123)", label: "ロイヤルパープル", fontColor: "white" },
        { name: "lt+20", color: "rgb(144,145,195)", label: "ふじいろ", fontColor: "black" },
        { name: "sf20", color: "rgb(120,120,160)", label: "ふじなんど", fontColor: "black" },
        { name: "d20", color: "rgb(84,82,124)", label: "いまむらさき", fontColor: "white" },
        { name: "dk20", color: "rgb(50,45,81)", label: "パープルネイビー", fontColor: "white" },
        { name: "p+20", color: "rgb(187,189,208)", label: "あわふじいろ", fontColor: "black" },
        { name: "v21", color: "rgb(112,63,150)", label: "すみれいろ", fontColor: "white" },
        { name: "v22", color: "rgb(129,55,138)", label: "パープル", fontColor: "white" },
        { name: "b22", color: "rgb(161,101,168)", label: "モーブ", fontColor: "white" },
        { name: "dp22", color: "rgb(97,36,105)", label: "きょうむらさき", fontColor: "white" },
        { name: "lt+22", color: "rgb(176,136,181)", label: "うすむらさき", fontColor: "black" },
        { name: "sf22", color: "rgb(144,113,148)", label: "こだいむらさき", fontColor: "black" },
        { name: "d22", color: "rgb(108,74,113)", label: "えびぞめ", fontColor: "white" },
        { name: "dk22", color: "rgb(67,40,72)", label: "ぶどういろ", fontColor: "white" },
        { name: "p+22", color: "rgb(200,185,201)", label: "あさむらさき", fontColor: "black" },
        { name: "v23", color: "rgb(143,46,124)", label: "チリアンパープル", fontColor: "white" },
        { name: "v24", color: "rgb(173,46,108)", label: "マゼンタ", fontColor: "white" },
        { name: "b24", color: "rgb(208,103,142)", label: "あやめいろ", fontColor: "black" },
        { name: "dp24", color: "rgb(134,29,85)", label: "ピアニー", fontColor: "white" },
        { name: "lt+24", color: "rgb(217,142,165)", label: "オーキッド", fontColor: "black" },
        { name: "sf24", color: "rgb(180,120,139)", label: "うめむらさき", fontColor: "black" },
        { name: "d24", color: "rgb(139,79,101)", label: "えびいろ", fontColor: "white" },
        { name: "dk24", color: "rgb(97,45,70)", label: "レーズン", fontColor: "white" },
        { name: "FL4", color: "rgb(240,194,144)", label: "ピーチ", fontColor: "black" },
        { name: "FL5", color: "rgb(219,163,107)", label: "オークル", fontColor: "black" },
        { name: "offN1", color: "rgb(251,241,229)", label: "オフホワイト", fontColor: "black" },
        { name: "offN2", color: "rgb(243,230,197)", label: "アイボリー", fontColor: "black" },
        { name: "offN4", color: "rgb(245,224,193)", label: "クリームイエロー", fontColor: "black" },
        { name: "BR7", color: "rgb(95,80,59)", label: "ダークブラウン", fontColor: "white" },
        { name: "W", color: "rgb(255,255,255)", label: "ホワイト", fontColor: "black" },
        { name: "Gy3.5", color: "rgb(84,84,84)", label: "グレー", fontColor: "white" },
        { name: "BK", color: "rgb(0,0,0)", label: "ブラック", fontColor: "white" }
      ]
    }
  }
}
</script>

<style scoped>
.btn {
  height: 50px;
  width: 80px;
  border-radius: 8px;
  font-size: 10px;
  vertical-align: middle;
  margin: 15px;
  border-color: rgba(118, 118, 118, 0.3);
}
.tabs {
  list-style: none;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
}
.tabs li:not(:first-child) {
  margin-left: 10px;
}
.tabs li {
  background-color: rgba(231, 142, 26, 0.39);
}
.active {
  color: brown;
}
.left {
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>